import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { signIn } from '@store/guest/actions';
import { fetchBasketDetails } from '@store/basket/actions';

import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { SignIn } from './SignIn';

const mapStateToProps = (state, ownProps) => {
  const { homepage } = entitySelectors.getProperty(state, ownProps.id);

  const homepageId = homepage ? homepage.id : null;
  return {
    homepage: entitySelectors.getHomepage(state, homepageId),
    guest: guestSelectors.getGuest(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signIn,
      fetchBasketDetails,
    },
    dispatch
  );

export const SignInContainer: any = connect(mapStateToProps, mapDispatchToProps)(SignIn as any);
